import ApiService from "@/_services/api/api.service";
import appConfig from "@/app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

/**
 * Store Supplier Credit to the backend Via API
 * @type {{saveSupplierCredit(*): Promise<AxiosResponse<any>>}}
 */
const SupplierCreditService = {
  async saveSupplierCredit(payload) {
    const url = `api/Save_SupplierCredit`;

    return await ApiService.post(url, payload);
  },
};

export { SupplierCreditService };
